
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue';
import { getSmsCaptcha } from '@/api/user/login';
import { message, notification } from 'ant-design-vue';
import { useForm } from 'ant-design-vue/es/form';
import { LockOutlined, UserOutlined, MailOutlined } from '@ant-design/icons-vue';
import { AxiosError } from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  CHANGE_CURRENT_ORG,
  GET_CUSTOME_DATA_USER,
  GET_INFO,
  GET_MY_MENU_DATA_LIST,
  LOGIN,
  COMPLEX_LOGIN,
  MY_ORGINFO,
  MOBILE_LOGIN, SIMPLE_LIMIT_LOGIN, COMPLEX_LIMIT_LOGIN,
} from "@/store/modules/user/actions";
import { GetQueryString } from '@/utils/utils.ts';
import { sourceStore } from '@/utils/local-storage';
import { create_organization_by_user } from '@/api/sys';
import { SET_JUMP_NAMPSPACE } from '@/store/modules/user/mutations';
import { query_login_person_all_menu_project_list } from '@/api/permission/menu-manage';
import CryptoJS from 'crypto-js';
import { send_user_login_sms_code } from '@/api/sys-model';
import { get_wechat_app_id } from '@/api/wx-model';

export default defineComponent({
  name: 'Login',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const showWx = ref(true);
    const showMobile = ref(true);
    const my_org_list: any = ref([]);
    const my_all_menu_list: any = reactive([]);
    const my_main: any = ref('my_main');
    const activeKey: any = ref([]);
    const state = reactive({
      customActiveKey: 'tab1',
      loginBtn: false,
      loginType: 0,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      time: 60,
      smsSendBtn: false,
    });

    const modelRef: any = reactive({
      rememberMe: true,
      username: '',
      password: '',
      mobile: null,
      captcha: '',
      code: null,
      num: null,
    });
    const rulesRef = reactive({
      name: [{ required: true, message: '请输入组织名称', type: 'string' }],
      mobile: [
        {
          required: true,
          pattern: /^1[3456789]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: ['blur'],
        },
      ],
      code: [{ required: true, message: '请输入验证码' }],
    });
    const { validateInfos, validate, resetFields } = useForm(modelRef, rulesRef);
    const host: any = window.location.host;
    if (host == 'roll.8mu.com.cn') {
      showWx.value = true;
      showMobile.value = false;
    }
    const handleTabClick = (key: string) => {
      state.customActiveKey = key;
      resetFields();
      if (key == 'wx_tab' && showWx.value) {
        init_wx_login();
      }
    };

    const requestFailed = (err: AxiosError) => {
      console.log('requestFailed', err?.response?.data?.errorMessage);
      state.isLoginError = true;
      // notification.error({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).errorMessage || '请求出现错误，请稍后再试',
      //   duration: 4,
      // });
    };

    const loginSuccess = () => {
      router.push({ path: '/steel_tapping' });

      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        notification.success({
          message: '欢迎',
          description: '欢迎回来',
        });
      }, 1000);
      state.isLoginError = false;
    };

    const getCaptcha = (e: Event) => {
      e.preventDefault();

      validate('mobile')
        .then(values => {
          state.smsSendBtn = true;

          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60;
              state.smsSendBtn = false;
              window.clearInterval(interval);
            }
          }, 1000);

          const hide = message.loading('验证码发送中..', 0);
          getSmsCaptcha({ mobile: values.mobile })
            .then(res => {
              setTimeout(hide, 2500);
              notification.success({
                message: '提示',
                description: '验证码获取成功，您的验证码为：' + res.captcha,
                duration: 8,
              });
            })
            .catch(err => {
              setTimeout(hide, 1);
              clearInterval(interval);
              state.time = 60;
              state.smsSendBtn = false;
              requestFailed(err);
            });
        })
        .catch(err => {
          console.log('err', err);
        });
    };

    onMounted(() => {
      if (window.location.href.indexOf('sessionid') > 0) {
        const sessionid: string | undefined = GetQueryString('sessionid');
        if (sessionid == 'error') {
          state.customActiveKey = 'tab1';
          notification.success({
            message: '提示',
            description: '微信未绑定账号，请采用其他登录方式',
          });
          const newQuery = { ...route.query };
          delete newQuery.sessionid;
          // 执行路由替换（不会增加历史记录）
          router.replace({
            query: newQuery,
          });
        } else {
          sourceStore.set('sessionid', sessionid);
          store
            .dispatch(`user/${GET_INFO}`)
            .then(() => {
              return store.dispatch(`user/${MY_ORGINFO}`, {});
            })
            .then((res: any) => {
              my_main.value = 'my_menu_main';
              handleGetMenu(res.org_list);
            })
            .catch(err => {
              requestFailed(err);
            })
            .finally(() => {
              state.loginBtn = false;
            });
        }
      } else {
        store
          .dispatch(`user/${GET_INFO}`)
          .then(() => {
            return store.dispatch(`user/${MY_ORGINFO}`, {});
          })
          .then((res: any) => {
            my_main.value = 'my_menu_main';
            handleGetMenu(res.org_list);
          })
          .catch(() => {})
          .finally(() => {});
      }
      if (showWx.value) {
        init_wx_login();
      }
    });

    const getAppId = async () => {
      return new Promise(resolve => {
        get_wechat_app_id()
          .then((res: any) => {
            if (res && res?.app_id) {
              resolve(res.app_id);
            } else {
              resolve('');
              notification.info({
                message: '温馨提示',
                description: '未获取到appid，请刷新浏览器',
              });
            }
          })
          .catch(() => {
            resolve('');
          });
      });
    };
    const init_wx_login = async () => {
      const shcreem = window.location.href.split('//')[0];
      let href = window.location.href.replace(`${shcreem}//`, '').split('/')[0];
      if (process.env.NODE_ENV == 'development') {
        href = 'lt.8mu.com.cn';
      }
      const reg = /static_file[_A-Za-z0-9]*/;
      const namespace_arr: any = reg.exec(window.location.href);
      let namespace: any = null;
      if (namespace_arr && namespace_arr.length > 0) {
        namespace = namespace_arr[0].trim();
      }
      let app_id = await getAppId();
      setTimeout(() => {
        try {
          new (window as any)['WxLogin']({
            self_redirect: false,
            id: 'wxlogin',
            appid: app_id,
            scope: 'snsapi_login',
            redirect_uri: encodeURI(
              `${shcreem}//${href}/wx/wx_pc_login?next_url=${btoa(
                `${shcreem}//${href}/${namespace}/user/login`,
              )}`,
            ),
            state: 'formrecord',
          });
        } catch (error) {
          console.error('加载wxLogin.js 出错');
        }
      }, 50);
    };

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      const validateNames = state.customActiveKey === 'tab1' ? ['username', 'password'] : ['name'];
      state.loginBtn = true;
      validate(validateNames)
        .then(values => {
          // console.log('values', values);
          create_organization_by_user(values)
            .then((res: any) => {
              store.dispatch(`user/${GET_CUSTOME_DATA_USER}`, {
                org_id: Number(res.id),
              });
              store.dispatch(`user/${MY_ORGINFO}`, { org_id: res.id }).then(() => {
                store
                  .dispatch(`user/${GET_MY_MENU_DATA_LIST}`, {
                    org_id: Number(res.id),
                  })
                  .finally(() => {
                    loginSuccess();
                  });
              });
            })
            .catch(err => {
              requestFailed(err);
            })
            .finally(() => {
              state.loginBtn = false;
            });
        })
        .catch((/*err*/) => {
          // 屏蔽错误处理
          // requestFailed(err);
          state.loginBtn = false;
        });
    };
    // this.loginBtn = false;
    // this.stepCaptchaVisible = false;
    const splitString = (input: string): [string, string] | null => {
      const match = input.match(/^(.*?)_(\d+)$/); // 使用正则表达式匹配
      if (match) {
        return [match[1], match[2]]; // 返回拆分后的数组
      }
      return null; // 如果没有匹配到，则返回null
    };
    const handleLoginSubmit = () => {
      const validateNames =
        state.customActiveKey === 'tab1' ? ['username', 'password'] : ['mobile', 'captcha'];
      state.loginBtn = true;
      validate(validateNames)
        .then(values => {
          console.log('values', values);
          store
            .dispatch(`user/${SIMPLE_LIMIT_LOGIN}`, {
              ...values,
              type: state.customActiveKey === 'tab1',
            })
            .then((res: any) => {
              return store.dispatch(`user/${GET_INFO}`);
            })
            .then(() => {
              return store.dispatch(`user/${MY_ORGINFO}`, {});
            })
            .then((res: any) => {
              my_main.value = 'my_menu_main';
              handleGetMenu(res.org_list);
              const nexturl = window.localStorage.getItem('nexturl') || '';
              window.localStorage.setItem('nexturl', '');
              if (nexturl) {
                const reg = /static_file[_A-Za-z0-9]*/;
                const namespace_arr: any = reg.exec(nexturl);
                if (namespace_arr && namespace_arr.length > 0) {
                  const list: any = splitString(namespace_arr[0].trim());
                  handleGoMenu({ org_id: Number(list[1]), inner_url: list[0], nexturl });
                }
              }
            })
            .catch(err => {
              requestFailed(err);
            })
            .finally(() => {
              state.loginBtn = false;
            });
        })
        .catch((/*err*/) => {
          // 屏蔽错误处理
          // requestFailed(err);
          state.loginBtn = false;
        });
    };

    const handleGetMenu = (org_list: any) => {
      if (org_list.data.length > 0) {
        state.customActiveKey = 'tab2';
        my_org_list.value = org_list.data;
        activeKey.value = my_org_list.value[0].id;
        query_login_person_all_menu_project_list({})
          .then((res: any) => {
            my_all_menu_list.length = 0;
            res.forEach((item: any) => {
              my_all_menu_list.push(item);
            });
          })
          .catch(error => {
            requestFailed(error);
          });
      }
    };

    const select_org = (res: any) => {
      store.dispatch(`user/${GET_CUSTOME_DATA_USER}`, {
        org_id: Number(res.id),
      });
      store
        .dispatch(`user/${CHANGE_CURRENT_ORG}`, res)
        .then(() => {
          return store.dispatch(`user/${GET_MY_MENU_DATA_LIST}`, {
            org_id: Number(res.id),
          });
        })
        .then(() => {
          loginSuccess();
        });
    };
    const handleGoMenu = ({
      org_id,
      inner_url,
      nexturl,
      link_url = '',
      url_type = 'inner',
    }: any) => {
      if (url_type === 'link') {
        window.open(link_url, '_blank');
        return;
      }
      if (process.env.NODE_ENV == 'production') {
        const org_list = store.getters['user/org_list'];
        let namespace = '';
        if (inner_url.startsWith('http')) {
          location.href = inner_url;
        } else if (inner_url.indexOf('/') > 0) {
          const menu_str_list = inner_url.split('/');
          namespace = menu_str_list[0];
        } else {
          namespace = `${inner_url}_${org_id}`;
        }
        org_list.map((item: any) => {
          if (item.id == org_id) {
            // nameStore.set(STORAGE_CURRENT_ORG_KEY, item);
            store
              .dispatch(`user/${SET_JUMP_NAMPSPACE}`, namespace)
              .then(() => {
                return store.dispatch(`user/${CHANGE_CURRENT_ORG}`, item);
              })
              .then(() => {
                return store.dispatch(`user/${GET_MY_MENU_DATA_LIST}`, {
                  org_id: Number(org_id),
                });
              })
              .then(() => {
                return store.dispatch(`user/${GET_CUSTOME_DATA_USER}`, {
                  org_id: Number(org_id),
                });
              })
              .then(() => {
                if (nexturl) {
                  location.href = nexturl;
                } else {
                  if (inner_url.startsWith('http')) {
                    location.href = inner_url;
                  } else if (inner_url.indexOf('/') > 0) {
                    location.href = '/' + inner_url + '?t=' + new Date().getTime();
                  } else {
                    namespace = `${inner_url}_${org_id}`;
                    location.href = '/' + namespace + '/' + '?t=' + new Date().getTime();
                  }
                }
              })
              .catch((e: any) => {
                console.error(e);
                message.error('切换组织错误');
              })
              .finally(() => {
                store.dispatch(`user/${SET_JUMP_NAMPSPACE}`, null);
              });
          }
        });
      } else {
        location.href = '/';
      }
    };
    const handleComplexLoginSubmit = () => {
      const validateNames =
        state.customActiveKey === 'tab1' ? ['username', 'password'] : ['mobile', 'captcha'];
      state.loginBtn = true;
      validate(validateNames)
        .then(values => {
          console.log('values', values);
          getEncryptedFormData(values).then(new_values => {
            store
              .dispatch(`user/${COMPLEX_LIMIT_LOGIN}`, {
                ...new_values,
                type: state.customActiveKey === 'tab1',
              })
              .then((res: any) => {
                return store.dispatch(`user/${GET_INFO}`);
              })
              .then(() => {
                return store.dispatch(`user/${MY_ORGINFO}`, {});
              })
              .then((res: any) => {
                my_main.value = 'my_menu_main';
                handleGetMenu(res.org_list);
                const nexturl = window.localStorage.getItem('nexturl') || '';
                window.localStorage.setItem('nexturl', '');
                if (nexturl) {
                  const reg = /static_file[_A-Za-z0-9]*/;
                  const namespace_arr: any = reg.exec(nexturl);
                  if (namespace_arr && namespace_arr.length > 0) {
                    const list: any = splitString(namespace_arr[0].trim());
                    handleGoMenu({ org_id: Number(list[1]), inner_url: list[0], nexturl });
                  }
                }
              })
              .catch(err => {
                requestFailed(err);
              })
              .finally(() => {
                state.loginBtn = false;
              });
          });
        })
        .catch((/*err*/) => {
          // 屏蔽错误处理
          // requestFailed(err);
          state.loginBtn = false;
        });
    };

    async function getEncryptedFormData(formData: any) {
      const username = formData.username;
      const password = formData.password;

      try {
        // 1. 生成随机 salt 和 iv（16字节）
        const salt = CryptoJS.lib.WordArray.random(16);
        const iv = CryptoJS.lib.WordArray.random(16);

        // 2. 使用 PBKDF2 派生密钥（替代 Web Crypto API）
        const key = CryptoJS.PBKDF2(username, salt, {
          keySize: 256 / 32, // 256位密钥
          iterations: 100000,
          hasher: CryptoJS.algo.SHA256,
        });

        // 3. 加密密码（AES-GCM 模式需自行实现，这里用 AES-CBC 替代）
        const encryptedData = CryptoJS.AES.encrypt(password, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC, // 兼容性更好的模式
          padding: CryptoJS.pad.Pkcs7,
        });

        // 4. 返回 Base64 格式的结果
        return {
          username: username,
          encrypted_password: encryptedData.toString(),
          iv: iv.toString(CryptoJS.enc.Base64),
          salt: salt.toString(CryptoJS.enc.Base64),
        };
      } catch (error) {
        state.loginBtn = false;
        message.info('登录失败！请再次尝试或联系管理员');
        console.error('发生错误：', error);
        throw new Error('加密失败'); // 可以根据需要自定义错误信息
      }
    }
    const handleLogin = (e: Event) => {
      e.preventDefault();
      if (host == 'lt.8mu.com.cn' || host == '192.168.28.179') {
        handleLoginSubmit();
      } else {
        handleComplexLoginSubmit();
      }
    };
    const handleGetCode = () => {
      validate(['mobile']).then(values => {
        modelRef.num = 60;
        const timer = setInterval(() => {
          modelRef.num--;
          if (modelRef.num < 0) {
            clearInterval(timer);
          }
        }, 1000);
        send_user_login_sms_code({
          username: modelRef.username,
          mobile: values.mobile,
        })
          .then(() => {
            message.success('验证码获取成功');
          })
          .catch(() => {
            modelRef.num = 0;
          });
      });
    };
    const handleMobileLogin = (e: Event) => {
      e.preventDefault();
      validate(['mobile', 'code'])
        .then(values => {
          state.loginBtn = true;
          store
            .dispatch(`user/${MOBILE_LOGIN}`, {
              mobile: values.mobile,
              code: values.code,
            })
            .then(() => {
              return store.dispatch(`user/${GET_INFO}`);
            })
            .then(() => {
              return store.dispatch(`user/${MY_ORGINFO}`, {});
            })
            .then((res: any) => {
              my_main.value = 'my_menu_main';
              handleGetMenu(res.org_list);
              const nexturl = window.localStorage.getItem('nexturl') || '';
              window.localStorage.setItem('nexturl', '');
              if (nexturl) {
                const reg = /static_file[_A-Za-z0-9]*/;
                const namespace_arr: any = reg.exec(nexturl);
                if (namespace_arr && namespace_arr.length > 0) {
                  const list: any = splitString(namespace_arr[0].trim());
                  handleGoMenu({ org_id: Number(list[1]), inner_url: list[0], nexturl });
                }
              }
            })
            .catch(err => {
              requestFailed(err);
            })
            .finally(() => {
              state.loginBtn = false;
            });
        })
        .catch((/*err*/) => {
          // 屏蔽错误处理
          // requestFailed(err);
          state.loginBtn = false;
        });
    };
    const handleNoPassword = () => {
      router.push({
        path: '/user/register',
      });
    };
    return {
      ...toRefs(state),
      showWx,
      showMobile,
      my_org_list,
      modelRef,
      validateInfos,
      my_all_menu_list,
      activeKey,
      my_main,

      select_org,
      handleTabClick,
      handleSubmit,
      handleLoginSubmit,
      handleComplexLoginSubmit,
      handleLogin,
      getCaptcha,
      handleGoMenu,
      handleGetCode,
      handleMobileLogin,
      handleNoPassword,
    };
  },
  components: {
    UserOutlined,
    LockOutlined,
    MailOutlined,
  },
});
